module.exports = __webpack_public_path__ + "static/kv_mobile-6686df98a59f8e40a11049215c3d1b06.png";